<template>
    <div class="load-mask position-fixed vw-100 vh-100">
        <b-row no-gutters class="justify-content-center vw-100 vh-100">
            <b-col sm="6" class="px-5 align-self-center text-center">
                <b-img src="/images/load.gif"></b-img>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    computed: {
        ...mapGetters([
        ])
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    },
}
</script>

<style>
.load-mask {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3000;

    background: rgba(255,255,255,0.5);
}
</style>
